// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/requestcatalog/v1/requestcatalogbundles.proto" (package "c1.api.requestcatalog.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { TaskView } from "../../task/v1/task";
import { Duration } from "../../../../google/protobuf/duration";
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestBundleRequest
 */
export interface RequestBundleRequest {
    /**
     * @generated from protobuf field: string catalog_id = 1;
     */
    catalogId: string;
    /**
     * @generated from protobuf field: string requested_for_id = 2;
     */
    requestedForId: string;
    /**
     * @generated from protobuf field: string request_reason = 3;
     */
    requestReason: string;
    /**
     * @generated from protobuf field: google.protobuf.Duration grant_duration = 5;
     */
    grantDuration?: Duration;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestBundleResponse
 */
export interface RequestBundleResponse {
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskView task = 1;
     */
    task?: TaskView;
}
// @generated message type with reflection information, may provide speed optimized methods
class RequestBundleRequest$Type extends MessageType<RequestBundleRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestBundleRequest", [
            { no: 1, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "requested_for_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "request_reason", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "grant_duration", kind: "message", T: () => Duration, options: { "validate.rules": { duration: { gt: {} } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestBundleRequest
 */
export const RequestBundleRequest = new RequestBundleRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestBundleResponse$Type extends MessageType<RequestBundleResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestBundleResponse", [
            { no: 1, name: "task", kind: "message", T: () => TaskView }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestBundleResponse
 */
export const RequestBundleResponse = new RequestBundleResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.requestcatalog.v1.RequestCatalogBundlesService
 */
export const RequestCatalogBundlesService = new ServiceType("c1.api.requestcatalog.v1.RequestCatalogBundlesService", [
    { name: "RequestBundle", options: { "authz.method": { role: "VIEWER" } }, I: RequestBundleRequest, O: RequestBundleResponse }
]);
